module.exports = __webpack_public_path__ + "static/img/passport.ff258fa3.png";